import { ChakraProvider } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { AlertWrapper } from "@components/index";
import theme from "@root/themes/theme";
import darkTheme from "@root/themes/darkTheme";
import { GlobalContextProvider } from "@root/context/global-context";
import { OrganizationBrandingProvider } from "@root/context/organization-branding-context";

export const ChakraWrapper: React.FC<any> = ({ children, ...rest }) => {
  const currentTheme = localStorage.getItem("chakra-ui-color-mode");

  const [selectedTheme, setSelectedTheme] = useState(currentTheme || "light");

  useEffect(() => {
    const handleStorageChange = () => {
      setSelectedTheme(localStorage.getItem("chakra-ui-color-mode") || "");
    };

    window.addEventListener("click", handleStorageChange);

    return () => {
      window.removeEventListener("click", handleStorageChange);
    };
  }, []);

  return (
    <ChakraProvider
      theme={selectedTheme === "dark" ? darkTheme : theme}
      {...rest}
    >
      <GlobalContextProvider>
        <OrganizationBrandingProvider>
          <AlertWrapper>{children}</AlertWrapper>
        </OrganizationBrandingProvider>
      </GlobalContextProvider>
    </ChakraProvider>
  );
};
